module.exports = __webpack_public_path__ + "media/images/builder/webpage-f8a3862926cddf210ff4868b8785c89e.png";